 <!-- <div class="container mt-5 pt-5">
    
<div id="txtNumeroTarjeta" class="input-control"></div>

<div id="txtFechaVencimiento" class="input-control"></div>

<div id="txtCvv" class="input-control"></div>

<button class="btn-pagar" (click)="pagar()">Pagar</button>
</div> -


 -->
<!-- <a (click)="openForm()">pago</a> -->

<div class="container mt-5 pt-5">
    <a (click)="buscarDNI()">Buscar</a>


    <a (click)="cargarPrepagoNiubiz()">Pago</a>
    <div id="btn_pago">

    </div>

</div>


